interface CodeBlockProps {
  title?: string;
  children: React.ReactNode;
}

export function CodeBlock({ title, children }: CodeBlockProps) {
  return (
    <div className="rounded border border-border bg-bg-surface overflow-hidden">
      {title && (
        <div className="border-b border-border px-4 py-2">
          <span className="font-mono text-xs text-text-muted">{title}</span>
        </div>
      )}
      <pre className="overflow-x-auto p-4 font-mono text-sm leading-relaxed text-text-muted">
        {children}
      </pre>
    </div>
  );
}
